export default {
    /* GET_MACHINES
    ---------------------------------------------------------------
    */
    GET_MACHINES_REQUEST: (state) => {
        state.machinesLoading = true
    },
    GET_MACHINES_SUCCESS: (state, data) => {
        state.machines = data
        state.machinesLoading = false
    },
    GET_MACHINES_FAILURE: (state) => {
        state.machinesLoading = false
    },

    UPDATE_MACHINE: (state, data) => {
        const index = state.machines.findIndex(item => item.id == data.id)

        state.machines[index] = data
    },

    SET_MACHINES_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_MACHINES_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}